/**
 * Light validation for Discord channel URLs.
 * Returns true if the input is empty (valid = no link) or matches the
 * "https://discord.com/channels/..." pattern. Trims whitespace.
 */
export function isValidDiscordUrl(input: string): boolean {
  const trimmed = input.trim();
  if (trimmed === '') return true;
  return /^https:\/\/discord\.com\/channels\/.*/.test(trimmed);
}

/** Default channel pre-filled in the "new session" / edit-stream modal. */
export const DEFAULT_DISCORD_URL = 'https://discord.com/channels/909751305029967903/1384831595411673088';
